export default "__VITE_ASSET__DV_08SjA__"